import React from "react";
import { Skeleton as AntSkeleton } from "antd";
import Skeleton from "react-loading-skeleton";

const Loading = ({ isSkeleton, ...props }) => {
  return isSkeleton ? <AntSkeleton {...props} /> : <Skeleton {...props} />;
};

export default Loading;
